<div class="content-wrapper">
    <ng-content *ngIf="!slotLeft && !slotRight && !slotLeft"></ng-content>
    <ng-content select="unh-slot-left"></ng-content>
    <ng-content select="unh-slot-middle"></ng-content>
    <ng-content select="unh-slot-right"></ng-content>
</div>